import withSplitting from './withSplitting';

export const ReputationManagement = withSplitting(() => import('./ReputationManagement'));
export const Profile = withSplitting(() => import('./Profile'));
